'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

function SidebarBrowseByMerchant({
  routes,
  merchants,
  className = '',
  localisation = {},
  bloodhound,
}) {
  if (!Array.isArray(merchants) || !merchants.length) {
    return null;
  }

  const merchantList = merchants.map(merchant =>
    h('li.sidebar-browse-item', [
      h(
        'a.sidebar-browse-link',
        {
          href: routes.merchant.show.replace(
            '{merchantSlug}',
            merchant.merchantSlug || merchant.MerchantSlug
          ),
          'data-bhc': `store:${merchant.merchantSlug || merchant.MerchantSlug}`,
        },
        merchant.merchantName || merchant.MerchantName
      ),
    ])
  );

  return h(
    `.sidebar-browse.${className}`,
    h(
      '.sidebar-browse-inner',
      {
        'data-bhw': bloodhound,
      },
      [
        localisation.resource &&
          h(Translate, localisation.data, localisation.resource),
        h('ul.sidebar-browse-list', merchantList),
      ]
    )
  );
}

module.exports = SidebarBrowseByMerchant;
